<template>
  <v-app>
    <v-content>
      <v-container v-if="!carregandoConfiguracoes">
        <v-overlay
          :value="true"
          :z-index="zIndexDoTutorial"
          v-if="usuarioLogado.exibeTutorialDeNavegacao"
          absolute>
          <v-row justify="center" no-gutters class="text-center">
            <v-col cols="8" style="margin-bottom: 400px" v-if="zIndexDoTutorial == 4">
              <h4>Selecione uma organização ou um grupo no qual deseja aplicar a assinatura de e-mail.</h4>
            </v-col>
          </v-row>
        </v-overlay>
        <v-row justify="center">
          <v-col
            xs="3"
            sm="3"
            md="3"
            lg="3"
            xl="3">
            <v-row no-gutters>
              <v-col  :class="`${zIndexDoTutorial == 3 ? 'etapa-tutorial-ativa' :  'etapa-tutorial-inativa' &&  ativarFundoTransparente()}`">
                <div>
                  <c-lista-usuario :grupoAtivo="grupo"/>
                  <h4
                    v-if="zIndexDoTutorial == 3"
                    class="cor-branca mt-3"
                  >Veja a lista de membros que pertencem ao grupo selecionado.</h4>
                </div>
              </v-col>
              <v-col
                cols="12"
                :class="`${zIndexDoTutorial == 2 || zIndexDoTutorial == 3 ? 'etapa-tutorial-ativa' :  'etapa-tutorial-inativa' &&  ativarFundoTransparente()}`"
                order-md="1"
                order-lg="2"
                class="text-lg-start text-center">
                <h4
                  v-if="zIndexDoTutorial == 2 || zIndexDoTutorial == 3"
                  class="cor-branca mt-lg-12 pt-lg-12"
                >Edite e costumize sua assinatura para deixá-la com a identidade da sua empresa. Por fim, aplique, agende por um período de tempo ou salve sua assinatura.</h4>
              </v-col>
            </v-row>
          </v-col>

          <v-col xs="12" sm="12" md="6" lg="6" xl="6">
            <v-row justify="center">
              <v-col xs="12" sm="12" md="12" lg="12" xl="12" class="pt-0">
                <v-card
                  outlined
                  :class="`${zIndexDoTutorial == 4 ? 'etapa-tutorial-ativa' :  'etapa-tutorial-inativa' &&  ativarFundoTransparente()}`">
                  <v-card-actions>
                    <v-row no-gutters>
                      <v-col cols="1" align-self="center" class="pl-2">
                        <v-icon>mdi-account-group</v-icon>
                      </v-col>
                      <v-col cols="9">
                        <!--Botão para selecionar as organizações-->
                        <v-btn
                          :color="colorBtnOrganizacao"
                          class="titulos grupos-assinaturas pl-1"
                          text
                          :disabled="desabilitarOrgOuGrupo.org"
                          @click="ativarOrganizacao()"
                        >organização</v-btn>
                        <v-btn
                          :color="colorBtnGrupoUsuarios"
                          class="titulos grupos-assinaturas"
                          text
                          :disabled="desabilitarOrgOuGrupo.grupo"
                          @click="ativarGrupo()"
                        >grupos
                          <v-tooltip bottom v-if="grupo == true">
                            <template v-slot:activator="{ on, attrs }" >
                              <v-icon small class="ml-2" color="error" v-on="on" v-bind="attrs">mdi-alert-octagon</v-icon>
                            </template>
                            <span>Não há tratativa para grupos com todos os usuários.</span>
                          </v-tooltip>
                        </v-btn>
                      </v-col>

                      <v-col cols="2" align-self="center" class="text-end pr-2">
                        <c-duvidas
                          titulo="Organização / Grupos"
                          texto="Selecione uma organização ou grupo para criar a assinatura de e-mail. Caso selecione um grupo, será necessário selecionar os usuários do grupo."
                        ></c-duvidas>
                      </v-col>
                    </v-row>
                  </v-card-actions>

                  <v-expand-transition>
                    <div v-show="show">
                      <v-divider></v-divider>
                      <!--Listar as organizações-->
                      <div v-if="organizacao">
                        <c-lista-organizacao />
                      </div>
                      <!--FINAL-->
                      <div v-if="grupo">
                        <c-lista-grupo />
                      </div>
                       

                      <v-progress-linear indeterminate v-if="carregando" height="3px"></v-progress-linear>
                    </div>
                  </v-expand-transition>

                </v-card>
                <v-card
                  class="mt-3"
                  outlined
                  :class="`${zIndexDoTutorial == 2 || zIndexDoTutorial == 3 ? 'etapa-tutorial-ativa' :  'etapa-tutorial-inativa' && ativarFundoTransparente()}`">
                  <v-card-title>
                    <v-row no-gutters>
                      <v-col cols="1" class="text-start">
                        <v-icon>mdi-email-edit</v-icon>
                      </v-col>
                      <v-col cols="4" align-self="center" class="titulos">Modelo de Assinatura</v-col>
                      <v-col cols="5" align-self="center" class="listas">{{salvandoModelo.visivel ? salvandoModelo.texto : ""}}</v-col>
                      <v-col cols="2" align-self="center" class="text-end">
                        <c-duvidas
                          titulo="Modelo de assinatura"
                          texto="Edite e customize sua assinatura de e-mail de acordo com a identidade da empresa. Por fim, aplique, agende por um período de tempo ou salve sua assinatura."
                        ></c-duvidas>
                      </v-col>
                    </v-row>
                  </v-card-title>
                  <v-card-text>
                    <v-row no-gutters>
                      <v-col cols="12">
                        <c-editor-assinatura :assinaturaDeEmail="assinaturaDeEmail"></c-editor-assinatura>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>

          <v-col xs="10" sm="10" md="3" lg="3" xl="3">
            <v-row no-gutters>
              <v-col
                cols="12"
                :class="`${zIndexDoTutorial == 2 || zIndexDoTutorial == 3 ? 'etapa-tutorial-ativa' :  'etapa-tutorial-inativa' &&  ativarFundoTransparente()}`"
                order-md="2"
                order-lg="1">
                <c-campos/>
                <h4
                  v-if="zIndexDoTutorial == 2 || zIndexDoTutorial == 3"
                  class="cor-branca mt-2"
                >Selecione os campos que deseja que sua assinatura de e-mail contenha.</h4>
              </v-col>            
            </v-row>
          </v-col>
          <v-col cols="12" class="text-center etapa-tutorial-ativa" v-if="usuarioLogado.exibeTutorialDeNavegacao">
            <v-icon color="white" @click="voltarEtapaDoTutorial()" style="margin-left: 110px">mdi-chevron-left</v-icon>
            <v-icon
              v-for="t in tutorial"
              :key="t.etapa"
              color="white"
              class="ml-1 mr-1"
              small
            >{{t.ativo ? "mdi-checkbox-blank-circle" : "mdi-checkbox-blank-circle-outline"}}</v-icon>
            <v-icon color="white" @click="avancarEtapaDoTutorial()" >mdi-chevron-right</v-icon>
            <v-btn
              style="float: right"
              color="white"
              text
              tile
              @click="finalizarTutorial()"
            >CONCLUIR</v-btn>
          </v-col>
        </v-row>
      </v-container>
      <v-container v-else class="fill-height">
        <v-row justify="center">
          <v-col align-self="center" cols="12" class="text-center">
            <v-progress-circular indeterminate color="darkGrey" size="170" width="4"></v-progress-circular>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import ListaOrganizacao from "../components/assinaturas/organizacaoGrupoUsuario/ListaOrganizacao";
import EditorAssinatura from "../components/assinaturas/EditorAssinatura.vue";
import ListaUsuarios from "../components/assinaturas/organizacaoGrupoUsuario/ListaUsuarios";
import ListaGrupo from "../components/assinaturas/organizacaoGrupoUsuario/ListaGrupo";
import { mapState, mapActions } from "vuex";
import Campos from "../components/assinaturas/modelosCampos/Campos";
import { bus } from "../main";
import { atualizarParcialmente, receber } from "../mixins/RequisicaoMixin";
import { headersPadrao } from "../mixins/HeadersMixin";
import Duvidas from "../components/assinaturas/Duvidas";

export default {
  components: {
   "c-lista-organizacao": ListaOrganizacao,
   "c-lista-usuario": ListaUsuarios,
   "c-lista-grupo": ListaGrupo,
    "c-editor-assinatura": EditorAssinatura,
    "c-campos": Campos,
    "c-duvidas": Duvidas
  },
  data: () => ({
    desabilitarOrgOuGrupo:{
      org: false, 
      grupo: false
    },
    colorBtnGrupoUsuarios: "grey",
    colorBtnOrganizacao: "purple",
    colorBtnTodosUsuarios: "grey",
    show: true,
    organizacao: true,
    grupo: false,
    zIndexDoTutorial: 4,
    usuarioLogado: {},
    tutorial: [
      { etapa: 1, ativo: true },
      { etapa: 2, ativo: false }
    ],
    salvandoModelo: {
      status: false,
      texto: "",
      visivel: false
    },
    assinaturaDeEmail: {},
    carregando: false,
    carregandoConfiguracoes: true
  }),
  computed: {
    ...mapState(["listaUsuariosGrupos", "listaUsuarios", "aplicarAssinatura"])
  },
  methods: {
    ...mapActions(["fecharListaDeUsuarios", 
    "arrastarElemento", 
    "filtrarTagDeAssinatura", 
    "atualizarHtml", 
    "atualizarConteudoAssinatura",
    "desativarComponenteOrganizacao",
    "carregouUsuarios",
    "desativarEditorAssinatura"]),

    desmarcarCheckbox() {
      const carregarCamposNaAssinatura = [ "email", "nome", "cargo", "departamento", "localidade", "telefone", 
      "celular", "nome_do_andar", "secao_do_andar", "codigo_do_funcionario"];
      carregarCamposNaAssinatura.map(nomeDaTag => {
        this.filtrarTagDeAssinatura({
          nome: nomeDaTag,
          value: false
        });
      });
    },
    fecharListaDeUsuariosDoGrupo(){
      this.fecharListaDeUsuarios({
        status: false,
        mensagem: "Não existe usuários neste grupo"});
    },
    ativarOrganizacao() {
      this.organizacao = true;
      this.grupo = false;
      this.show = true;
      this.colorBtnGrupoUsuarios = "grey";
      this.colorBtnTodosUsuarios = "grey";
      this.colorBtnOrganizacao = "purple";
      this.limparDadosDaMemoria();
      this.desmarcarCheckbox();
      this.fecharListaDeUsuariosDoGrupo();
      this.atualizarConteudoAssinatura("Organizacao");
    },
    ativarGrupo() {
      this.grupo = true;
      this.organizacao = false;
      this.show = true;
      this.colorBtnGrupoUsuarios = "purple";
      this.colorBtnOrganizacao = "grey";
      this.colorBtnTodosUsuarios = "grey";
      this.limparDadosDaMemoria();
      this.desmarcarCheckbox();
      this.atualizarConteudoAssinatura("Grupo");
    },
    selecionarTodosUsuarios() {
      this.colorBtnGrupoUsuarios = "grey";
      this.colorBtnOrganizacao = "grey";
      this.colorBtnTodosUsuarios = "purple";
      this.show = false;
    },
    abrirCalendario() {
      this.dialog = true;
      setTimeout(() => {
        document.getElementById("salvar").focus();
      }, 50);
    },
    irParaSegundoPassoTutorial() {
      this.zIndexDoTutorial = 3;
      this.tutorial[1].ativo = true;
    },
    irParaTerceiroPassoTutorial() {
      this.zIndexDoTutorial = 2;
      this.tutorial[1].ativo = true;
    },
    async finalizarTutorial() {
      var url = `/api/v1/usuarios/${this.usuarioLogado.idDoUsuario}/primeiro-acesso`;
      await atualizarParcialmente(url, headersPadrao())
        .then(() => {
          this.usuarioLogado.exibeTutorialDeNavegacao = false;
          this.zIndexDoTutorial = 0;
          localStorage.setItem(
            "usuarioLogado",
            JSON.stringify(this.usuarioLogado)
          );
        })
        .catch(erro => {
          if(erro.request.status == 404){
            this.$store.commit("atualizarMensagemDeErro", JSON.parse(erro.request.response).debugMessage)
            this.$store.commit("erro");
          }else this.$store.commit("erro", "Erro ao concluir o tutorial.")
        })
        .finally(()=>this.desativarComponenteOrganizacao(false));
    },
    verificarSeContinuaTutorial() {
      if (this.usuarioLogado.exibeTutorialDeNavegacao) return true;
      else this.zIndexDoTutorial = 0;
    },
    voltarEtapaDoTutorial() {
      var etapasAtivas = this.tutorial.filter(e => e.ativo);
      var etapaAtual = etapasAtivas.pop();
      var indexDaEtapaAtual = this.tutorial.indexOf(etapaAtual);
      if (indexDaEtapaAtual != 0)
        this.tutorial[indexDaEtapaAtual].ativo = false;
      switch (etapaAtual.etapa) {
        case 1:
          break;
        case 2:
          this.zIndexDoTutorial = 4;
          break;
        case 3:
          this.irParaSegundoPassoTutorial();
          break;
        case 4:
          this.irParaTerceiroPassoTutorial();
          break;
      }
    },
    avancarEtapaDoTutorial() {
      var etapasAtivas = this.tutorial.filter(e => e.ativo);
      var etapaAtual = etapasAtivas.pop();
      var indexDaEtapaAtual = this.tutorial.indexOf(etapaAtual);
      if (indexDaEtapaAtual != 3)
        this.tutorial[indexDaEtapaAtual + 1].ativo = true;
      switch (etapaAtual.etapa) {
        case 1:
          this.irParaSegundoPassoTutorial();
          break;
        case 2:
          this.irParaTerceiroPassoTutorial();
          break;
        case 3:
          break;
      }
    },
    buscarModeloDeAssinatura(url){
      this.desativarEditorAssinatura(true);
      this.carregando = true;
       this.desabilitarOrgOuGrupo = {
          org: true,
          grupo: true
        };
      receber(url, headersPadrao())
      .then(resposta => {
        this.assinaturaDeEmail = resposta;
        this.$store.commit("atualizarIdDoTemplate", this.assinaturaDeEmail.id);
      })
      .catch(erro => {
        this.assinaturaDeEmail = {
          cargo: false,
          celular: false,
          codigoDoFuncionario: false,
          departamento: false,
          email: false,
          html:'',
          id: null,
          localidade: false,
          nome: false,
          nomeDoAndar: false,
          secaoDoAndar: false,
          telefone: false,
        }
        if(erro.request.status == 404){
          this.$store.commit("atualizarMensagemDeErro", JSON.parse(erro.request.response).debugMessage)
          this.$store.commit("erro");
        }else this.$store.commit("erro", "Erro ao buscar modelo de assinatura.") 
        this.$store.commit("atualizarIdDoTemplate", null);
      })
      .finally(() => {
        this.desativarEditorAssinatura(false);
        this.desabilitarOrgOuGrupo = {
          org: false,
          grupo: false
        };
        this.carregando = false;
        this.desativarComponenteOrganizacao(false);
      }
     )
    },

    montarUrl(idDoCliente, idOrganizacaoOuGrupo){
      // api/v1/templates/busca?idDoTempllate=123&cliente=123&organizacao=123&grupo=123
      const tipos = {
        "organizacao": function(){
          const urlOrganizacao = `/api/v1/templates/busca?cliente=${idDoCliente}&organizacao=${idOrganizacaoOuGrupo}&grupo=`;
          return urlOrganizacao;
        }, 
        "grupo": function(){
          const urlGrupo = `/api/v1/templates/busca?cliente=${idDoCliente}&organizacao=&grupo=${idOrganizacaoOuGrupo}`;
          return urlGrupo;
        }
      }
      return tipos;
    },
    verificarConfiguracoes(){
      var idDoCliente = JSON.parse(localStorage.getItem("usuarioLogado")).cliente;
      receber(`api/v1/clientes/${idDoCliente}/configuracoes`, headersPadrao())
      .then(() => this.carregandoConfiguracoes = false)
      .catch(() => {
        this.$store.commit("erro", "As configurações para este cliente não foram realizadas. Realize-as em 'Configurações' para acessar esta página.");
        if(this.usuarioLogado.papel == "CLIENTE") this.$router.push({name: "Agendamentos"})
        else this.$router.go(-1);
      })
    },
    ativarFundoTransparente(){
      if(this.usuarioLogado.exibeTutorialDeNavegacao == true) return "fundo-transparente"
    },
    limparDadosDaMemoria(){
      //Testando deploy
      const grupoOuOrg = {
        id: null,
        path: null,
        tipo: null,
        nome: null
      } 
      this.$store.commit("adicionarOrganizacaoOuGrupo", grupoOuOrg);
    },
    habilitarCamposPosSalvamento(){
      this.desativarComponenteOrganizacao(false);
      this.desabilitarOrgOuGrupo.org = false;
      this.desabilitarOrgOuGrupo.grupo = false;
      this.carregouUsuarios(true);
    },
    desabilitarCamposDuranteSalvamento(){
      this.desativarComponenteOrganizacao(true);
      this.desabilitarOrgOuGrupo.org = true;
      this.desabilitarOrgOuGrupo.grupo = true;
      this.carregouUsuarios(false);
    },
  },
  watch: {
    "$store.state.aplicarAssinatura": function(aplicarAssinatura){
      if (this.verificarSeContinuaTutorial() && aplicarAssinatura.id != null){
        this.irParaTerceiroPassoTutorial();
        if(aplicarAssinatura.tipo == "grupo")this.irParaSegundoPassoTutorial()
        else this.$store.state.listaUsuarios = [];  
      }else {
        if(aplicarAssinatura.id != null) {
          var idDoCliente = JSON.parse(localStorage.getItem("usuarioLogado")).cliente;
          var idDaOrganizacaoOugrupo = this.$store.state.aplicarAssinatura.id;
          const montarRequisicao = this.montarUrl(idDoCliente, idDaOrganizacaoOugrupo);
          const url = montarRequisicao[aplicarAssinatura.tipo];
          const urlParaRequisicao = url();
          this.buscarModeloDeAssinatura(urlParaRequisicao);
        }
      }
    }, 
  },
  created() {
    const aplicarAssinatura = {
      id: null,
      path: null,
      tipo: null
    }
    this.$store.commit("limparDadosDaOrganizacao", aplicarAssinatura)
    this.$store.commit("atualizarIdDoTemplate", null);
    //sempre que esse componente for carregado, as tags deverão carregar novamente
    const carregarCamposNaAssinatura = [ "email", "nome", "cargo", "departamento", "localidade", "telefone", 
      "celular", "nome_do_andar", "secao_do_andar", "codigo_do_funcionario"];
      carregarCamposNaAssinatura.map(nomeDaTag => {
        this.filtrarTagDeAssinatura({
          nome: nomeDaTag,
          value: false
        });
      });
      
    this.usuarioLogado = JSON.parse(localStorage.getItem("usuarioLogado"));
    bus.$on("salvandoAssinatura", (status, texto) => {
      this.desabilitarCamposDuranteSalvamento();
      this.salvandoModelo.visivel = true;
      this.salvandoModelo.status = status;
      this.salvandoModelo.texto = texto;
      setTimeout(() => {
        this.habilitarCamposPosSalvamento();
        this.salvandoModelo.texto = "";
        this.visivel = false;
      },3000)
    })
    this.verificarConfiguracoes();
  },
  destroyed() {
    this.desativarEditorAssinatura(true);
  },
};
</script>

<style lang="css">
.grupos-assinaturas {
  font-weight: 700 !important;
}
.cor-nome-dos-campos {
  color: black;
}

.descricao {
  font-size: 12px !important;
}
.cor-branca {
  color: white;
}
.etapa-tutorial-ativa {
  z-index: 4;
}
.etapa-tutorial-inativa {
  z-index: 0;
}
.fundo-transparente {
  opacity: 0.2;
}
</style>